export const disableForm = {
  methods: {
    disableFormElements(form) {
      for (let i = 0; i < form.elements.length; i++) {
        form.elements[i].disabled = true;
      }
      const checkboxes = form.querySelectorAll('.checkbox');
      checkboxes.forEach(box => box.classList.add('is-readonly'));

      const dropDowns = form.querySelectorAll('.dropdown-container');
      dropDowns.forEach(dropdown => dropdown.setAttribute('disabled', 'true'));
    }
  }
};
